module.exports = __webpack_public_path__ + "img/img_logo_bottom_new@2x.0a9746f.png";